export enum DocumentExtraItemType {
	MEDICAL_HISTORY_ITEM = 'medicalHistoryItem',
}
